import { Platform } from 'react-native';

import { useDeviceInfo } from '@/hooks/use-device-info';
import { useIsLargeScreen } from '@/hooks/use-is-large-screen';

/**
 * Whether to offer the Reports page here: on WEB, a desktop-width window or a tablet in either
 * orientation, never a phone. NEVER on native — the report screens are too heavy for the iOS
 * app and crash it; `app/reports/_layout.tsx` turns away deep links there too.
 *
 * The ONE rule for every Reports entry point (the drawer row and Home's Quick Links tile), so
 * the two cannot disagree about whether the page exists on this device. Permission is a
 * separate question — combine with `canViewReports`.
 */
export const useFitsReports = (): boolean => {
	const isLargeScreen = useIsLargeScreen();
	const { isTablet } = useDeviceInfo();
	if (Platform.OS !== 'web') return false;
	return isLargeScreen || isTablet;
};
